<template>
  <div class="container_linkto">
    <div class="banner"></div>
    <div class="container">
      <h3>联系我们</h3>
      <div class="base-info">
        <!-- <div class="base-info-item linkman">联系人：{{linkman}}</div> -->
        <div class="base-info-item phone" v-if="phone!=''">联系电话：{{phone}}</div>
        <div class="base-info-item email">邮箱：{{email}}</div>
        <div class="base-info-item address">详细地址：{{addr}}</div>
      </div>
      <div class="content">
        <div class="content-left">
          <Menu active-name="guangzhou" @on-select="selected" width="100px">
            <MenuItem name="guangzhou">广州</MenuItem>
            <!-- <MenuItem name="beijing">北京</MenuItem>
            <MenuItem name="shandong">山东</MenuItem>
            <MenuItem name="foshan">佛山</MenuItem> -->
          </Menu>
        </div>
        <div class="content-right">
          <baidu-map :cooperationSource="cooperationSource"></baidu-map>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaiduMap from "../../components/baiduMap"
const cooperationInfo = [{
  area: '广州',
  address: '兴民路222号之三805室（部位：A）',
  // address: '南方证券大厦',
  detailAddress: '广州市天河区兴民路222号之三805室（部位：A）',
  tel: '020-85656490',
  // linkman: '杨生',
  email: 'hr@jia-xin.cn',
  qq: ''
// }, {
//   area: '北京',
//   address: '北京市朝阳区向军南里二巷甲5号雨霖大厦',
//   detailAddress: '北京市朝阳区向军南里二巷甲5号雨霖大厦1215室',
//   tel: '13901118703',
//   linkman: '王女士',
//   email: 'wangpeiyu@jia-xin.cn',
//   qq: ''
// }, {
//   area: '山东',
//   address: '山东省济南市历下区经十路9777号鲁商国奥城',
//   detailAddress: '山东省济南市历下区经十路9777号鲁商国奥城4号楼1601室',
//   tel: '13711309528',
//   linkman: '程先生',
//   email: 'chengchao@jia-xin.cn',
//   qq: ''
// }, {
//   area: '佛山',
//   address: '广东省佛山市禅城区季华六路11号恒福中心',
//   detailAddress: '广东省佛山市禅城区季华六路11号恒福中心写字楼608室',
//   linkman: '魏先生',
//   tel: '15668313555',
//   email: 'wei_danyang@jia-xin.cn',
//   qq: ''
// }, {
//   area: '花都',
//   address: '广州市天河区兴民路222号之三805室（部位：A）',
//   detailAddress: '广州市天河区兴民路222号之三805室（部位：A）',
//   linkman: '魏先生',
//   tel: '13711309528',
//   email: 'wei_danyang@jia-xin.cn',
//   qq: ''
}]
export default {
  components: { BaiduMap },
  name: "index",
  data() {
    return {
      cooperationSource: cooperationInfo[0],
      addr: cooperationInfo[0].detailAddress,
      phone: cooperationInfo[0].tel,
      email: cooperationInfo[0].email,
      linkman: cooperationInfo[0].linkman
    }
  },

  // mounted(){
  //   cooperationSource:cooperationInfo[0]
  // },
  methods: {
    selected(value) {
      switch (value) {
        case 'beijing':
          this.cooperationSource = cooperationInfo[1]
          this.addr = cooperationInfo[1].detailAddress
          this.phone = cooperationInfo[1].tel
          this.email = cooperationInfo[1].email
          this.linkman = cooperationInfo[1].linkman
          break;
        case 'guangzhou':
          this.cooperationSource = cooperationInfo[0]
          this.addr = cooperationInfo[0].detailAddress
          this.phone = cooperationInfo[0].tel
          this.email = cooperationInfo[0].email
          this.linkman = cooperationInfo[0].linkman
          break;
        case 'foshan':
          this.cooperationSource = cooperationInfo[3]
          this.addr = cooperationInfo[3].detailAddress
          this.phone = cooperationInfo[3].tel
          this.email = cooperationInfo[3].email
          this.linkman = cooperationInfo[3].linkman
          break;
        case 'shandong':
          this.cooperationSource = cooperationInfo[2]
          this.addr = cooperationInfo[2].detailAddress
          this.phone = cooperationInfo[2].tel
          this.email = cooperationInfo[2].email
          this.linkman = cooperationInfo[2].linkman
          break;
      }
    }
  }
}
</script>
<style scoped lang="less" src="../../style/index.less"></style>
<style scoped lang="less" src="./index.less">
</style>



// WEBPACK FOOTER //
// src/page/Linkto/index.vue